import { store } from '@/_store'

export function authHeader(contentType) {
    // return authorization header with jwt token
    //let user = JSON.parse(localStorage.getItem('user'));

    let user = store.state.authentication.user;

    if (user && user.token) {
        if (contentType != null) {
            return {
                'Authorization': 'Bearer ' + user.token,
                'Content-Type': contentType,
                //'Content-Security-Policy': "default-src 'self' https://test.oliverlist.com"
                // 'Cache-Control': 'no-cache, no-store, must-revalidate, private',
                // 'Pragma': 'no-cache',
                // 'Expires': '0'
            };
        } else {
            return {
                'Authorization': 'Bearer ' + user.token
            };
        }
    } else {
        return {};
    }
}
